import { IS_SCHOOL_ADMIN } from './is-admin-actions';

const initialState = null;

/**
 * Is Admin Reducer
 *
 * Consumes IS_SCHOOL_ADMIN action
 *
 * @param {boolean} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {boolean} - whether user is a school admin
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case IS_SCHOOL_ADMIN:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./components/report-filters/redux/is-admin/is-admin-reducer.js